import React from 'react';
import {observer} from 'mobx-react';

import {Col, Input, Row, Select} from 'antd';

import agent_store, {filter_store} from '@store/Agent/AgentStore';

import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';

const Search = Input.Search;
const Option = Select.Option;

@observer
class AgentFilterForm extends React.Component {
    render() {
        let numberStyle = {
            fontSize: '22px',
            fontWeight: '700',
            marginLeft: '30px'
        };
        let tipStyle = {
            marginLeft: '10px'
        };

        return (
            <Row type="flex"
                 style={{
                     flex: '1'
                 }}
            >
                {<Col style={{
                    lineHeight: '35px'
                }}>
                    <MySearchComponent
                        defaultValue={{
                            typeMode: CustomerTypeSelect.TYPE_MODE_AGENT,
                            type: CustomerTypeSelect.getTypeName(CustomerTypeSelect.TYPE_MODE_AGENT, filter_store.type),
                            search: filter_store.search ? filter_store.search : '',
                        }}
                        hideAutoComplete
                        hideDatePicker
                        onClick={(values) => {

                            filter_store.setAttr({
                                search: values.search,
                                type: 2
                            });
                            agent_store.reloadDatas();

                        }}
                    />
                </Col>
                }
                <Col style={{
                    lineHeight: '35px',
                    marginLeft: '15px',
                    flex: 1,
                    textAlign: 'right',
                }}>
                    <span style={numberStyle}>{agent_store.total}</span>
                    <span style={tipStyle}>代理数</span>
                    <span style={numberStyle}>{agent_store.new_num}</span>
                    <span style={tipStyle}>今日新增</span>
                </Col>
            </Row>
        )
    }
}


export default AgentFilterForm;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/AgentFilterForm.jsx